import { Acl } from '@foundation/acls/model';
import { GenericRepository } from '@foundation/table/state';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AclsRepository extends GenericRepository<Acl> {
	constructor() {
		super('acl');
	}

	/**
	 * Fetch ACLs for a specific resource
	 */
	public getAclsForResource$(resourceId: string, resourceKind: string) {
		return this._requestService.getBasic$<{ acls: Acl[]; canWrite: boolean }>(`/api/resources/for/${resourceKind}/${resourceId}/acls`);
	}

	public updateAclRights$(
		resourceId: string,
		resourceKind: string,
		whoKind: 'user' | 'team' | 'anonymous',
		whoId: string | null,
		rights: {
			read?: 'add' | 'remove';
			write?: 'add' | 'remove';
			delete?: 'add' | 'remove';
		}
	) {
		return this._requestService.post$<Acl[]>(`/api/resources/for/${resourceKind}/${resourceId}/update-rights`, {
			whoKind,
			whoId,
			rights,
		});
	}

	/**
	 * Invite a user to the platform by email
	 */
	public inviteByEmail$(email: string) {
		return this._requestService.post$<{ message: string }>('/api/resources/invite-by-email', { email });
	}
}
